/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react'

export function useDebounce(value, delay) {
  // State and setters for debounced value
  const [debouncedValue, setDebouncedValue] = useState(value)

  useEffect(
    () => {
      // Update debounced value after delay
      const handler = setTimeout(() => {
        setDebouncedValue(value)
      }, delay)

      //Cuando cambia el valor o se desmonta llama al clearTimeOut
      return () => {
        clearTimeout(handler)
      }
    },
    [value, delay] // Only re-call effect if value or delay changes
  )

  return debouncedValue
}

export const useFetch = (client) => {
  const [data, setData] = useState(null)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)

  useEffect(() => {
    const getData = async () => {
      setLoading(true)
      try {
        const response = await client.index()
        setData(response.data)
        setLoading(false)
      } catch (e) {
        setError(e.message)
        setLoading(false)
        setData(null)
        console.log(e.message)
      }
    }
    getData()
  }, [])
  return { data, loading, error }
}
